import i18n from 'i18next'

class RankType {
    ranking = 'noRanking'

    static getOptions = () => ([
        {
            label: i18n.t('powerpoint.options.ranking.noRanking'),
            value: 'noRanking',
            name: 'ranking',
        },
        {
            label: i18n.t('powerpoint.options.ranking.lowToHigh'),
            value: 'lowToHigh',
            name: 'ranking',
        },
        {
            label: i18n.t('powerpoint.options.ranking.highToLow'),
            value: 'highToLow',
            name: 'ranking',
        },
        {
            label: i18n.t('powerpoint.options.ranking.aToZ'),
            value: 'aToZ',
            name: 'ranking',
        },
    ])

    toJSON() {
        return this.ranking
    }
}

export default RankType
